jQuery(document).ready(function(){
	
  jQuery('.free-del li:nth-child(2)').on('click',function(){
    console.log('asdasd');
window.location.href= '/cart';
});
/* jQuery(window).load(function() { 
	setTimeout(function(){
	 var sortcrntvl = jQuery('.styled-select').val();
	 if(sortcrntvl == null){
		 jQuery('.styled-select').val('manual');
	 }
	}, 1000);	
});  */
  jQuery("#product-loop").bind("DOMSubtreeModified", function(index) {
//     console.log('tree modified');
//     console.log(index);
//     setTimeout(function(){ 
    
//      jQuery('.create-at').each(function(){
//     var current_date = new Date();
//     var productdate = new Date(jQuery(this).text());
//     var newproddate = productdate;
//     var thirtydays = new Date(jQuery(this).text()).setDate(productdate.getDate() + 30); // add 30 days 
//     if(current_date.getTime()>=newproddate.getTime() && current_date.getTime()<=thirtydays){
//       jQuery(this).parent().append('<div class="sale-item icn newprod">New</div>')
//     }
//   });
//     }, 1500);
 
    });
  
    jQuery('.create-at').each(function(){
      
      var current_date = new Date();
      var productdate = new Date(jQuery(this).text());
      var newproddate = productdate;
      var thirtydays = new Date(jQuery(this).text()).setDate(productdate.getDate() + 30); // add 30 days 
      
      if(current_date.getTime()>=newproddate.getTime() && current_date.getTime()<=thirtydays){
        
        jQuery(this).parent().append('<div class="sale-item icn newprod">NEW</div>');
        
        
      }
    });
  
    
    jQuery('.limited-edition').each(function(){
      if(jQuery(this).text() != ''){
        jQuery(this).show();
      }
    });
  
  jQuery(".rating-bel-titl").click(function() {
  
   var w_size = jQuery(window).width();
  
  if(w_size <= 740){
     jQuery('html, body').animate({
        scrollTop: jQuery("#looxReviews").offset().top -60
    }, 2000);
    
  }
  else{
  
    jQuery('html, body').animate({
        scrollTop: jQuery("#looxReviews").offset().top
    }, 2000);
  }
  
});
/*jQuery('.dl-menu').css('height', jQuery(window).height());*/
	jQuery('#mobile-icon').click(function(){
		jQuery(this).toggleClass('open');
      	jQuery('.gridlock ul.dl-menu').toggleClass('mobile-open');
//       	jQuery('.page-wrap').toggleClass('mobile-open');
      	jQuery('#footer-wrapper').css('display', 'none');
        if(jQuery(this).hasClass('open')){
          jQuery('html').css('overflow', 'hidden');
        }else{
          jQuery('html').css('overflow', 'initial');
        }	
      
	});
  jQuery('.mobilebannerslide').on('click',function(){
      console.log('here13123');
    if($('.mobile-open').length > 0){
      jQuery('.gridlock ul.dl-menu').toggleClass('mobile-open');
    }else{
       window.location = jQuery(this).data("src");
    }
      
});
  jQuery('.page-wrap').click(function(){
	    jQuery('#mobile-icon').removeClass('open');
      	jQuery('.gridlock ul.dl-menu').removeClass('mobile-open');
      	jQuery('.page-wrap').removeClass('mobile-open');
       	jQuery('html').css('overflow', 'initial');
	});
  
  
  jQuery('.gridlock ul.dl-menu > li').click(function(ev) {
   
    ev.stopPropagation();
    
    jQuery(this).toggleClass('active');
    if ( jQuery(this).hasClass('active') ) {
    	jQuery(this).find('ul.dl-submenu').slideDown(500);
    } else {
    	jQuery(this).find('ul.dl-submenu').slideUp(500);
    }
  });
  
  jQuery(window).bind("load", function() {
    
  	var check_sold = jQuery('.swatch .swatch-element');
    if ( check_sold.hasClass('soldout') ) {
    	jQuery('.photo-swatch').css('margin', '0px');
    }
    var w_size = jQuery(window).width();
    
 /*   if(w_size <= 740){
      jQuery(window).scroll(function(){
        //console.log(jQuery(this).scrollTop());
        if ( jQuery(this).scrollTop() > 0 ) {
        	jQuery('#hello').css('display','none');
        } else {
        	jQuery('#hello').css('display','block');
        }
      });
    
    } */

    if(w_size > 740){
      
     jQuery(window).scroll(function(){
        //console.log(jQuery(this).scrollTop());
        if ( jQuery(this).scrollTop() > 0 ) {
          
          jQuery('.header-section header').css('display','none');
          jQuery('.bc-sf-search-suggestion-wrapper').css('top','65px');
          jQuery('.bc-sf-search-suggestion-wrapper').css('position','fixed');
          jQuery('.bc-sf-search-suggestion-wrapper').css('background','red');
         
        } else {
          
          jQuery('.header-section header').css('display','block');
          jQuery('.bc-sf-search-suggestion-wrapper').css('top','97.75px');
          jQuery('.bc-sf-search-suggestion-wrapper').css('position','absolute');
          jQuery('.bc-sf-search-suggestion-wrapper').css('background','black');
         
        }
      });


      /* Quick Size Hover On product Image */
      jQuery(document).on("mouseenter", ".prod-image", function(){
        jQuery( this ).find('.product-form').fadeIn( 100 );
      });
        jQuery(document).on("mouseleave", ".prod-image", function(){
      jQuery( this ).find('.product-form').fadeOut( 100 );
      });
    
    }
    
  });
  
});



// Hide Header on on scroll down



/*
window.setInterval(function(){
 if (FHSPROD.labelme.loadedJs === true) {
    FHSPROD.labelme.jQuery(document).ready(function() {
       labelInit(FHSPROD, FHSPROD.labelme.jQuery);
    })
} else {
    if (typeof jQuery === 'undefined') {
        loadScript('//code.jquery.com/jquery-1.11.1.min.js', function() {
            FHSPROD.jQuery = jQuery.noConflict(true);
            FHSPROD.jQuery(document).ready(function() {
                labelInit(FHSPROD, FHSPROD.jQuery);
            })
        })
    } else {
        jQuery(document).ready(function() {
            labelInit(FHSPROD, jQuery);
        })
    }
}


}, 5000);*/

//star scroll


// jQuery( ".prod-image" )
//   .on( "mouseenter", function() {
//      jQuery( this ).find('.product-form').fadeIn( 100 );
//   })
//   .on( "mouseleave", function() {
//    jQuery( this ).find('.product-form').fadeOut( 100 );
//   });
 
/*
jQuery( ".reveal .first-image" ).hover(
  function() {
    jQuery( this ).parent().parent().next('.product-form').fadeIn( 100 );
  }, function() {
   jQuery( this ).parent().parent().next('.product-form').fadeOut( 100 );
  }
);
*/
// Quick View Size


function quickaddToCartFail(jqXHR, textStatus, errorThrown){
  
   currentemt.parent().parent().prev('.check-wrap').prev('.check-wrap-cross').css('display','block');
   currentemt.parent().parent().prev('.check-wrap').prev('.check-wrap-cross').find('.checkmark_svg').addClass('fadeIn');
  setTimeout(function(){
        currentemt.parent().parent().prev('.check-wrap').prev('.check-wrap-cross').find('.checkmark_svg').removeClass('fadeIn');
   	    currentemt.parent().parent().prev('.check-wrap').prev('.check-wrap-cross').css('display','none');
    }, 3000); 
  
  var response = jQuery.parseJSON(jqXHR.responseText);

  //jQuery('.add-to-cart-msg').addClass('error').text(response.description).fadeIn().delay(3000).fadeOut();
}

function quickaddToCartSuccess (jqXHR, textStatus, errorThrown){
  currentemt.parent().parent().prev('.check-wrap').css('display','block');
   currentemt.parent().parent().prev('.check-wrap').find('.checkmark').addClass('fadeIn');
   jQuery('.available').css('pointer-events','none');
     setTimeout(function(){
        currentemt.parent().parent().prev('.check-wrap').find('.checkmark').removeClass('fadeIn');
   	    currentemt.parent().parent().prev('.check-wrap').css('display','none');
        jQuery('.available').css('pointer-events','visible');
    }, 3000); 
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  
  jQuery(document).ajaxComplete(function() {
    Currency.convertAll(defaultCurrency, Currency.currentCurrency);
  });
  
 
}


jQuery(document).ready(function(){
// Sliding Cart 
jQuery('.cart-overview').click(function(){
    jQuery('.sd_minifixinner').click();
    
});
  
// Remove Empty P Tags  
  
  
  
  
// Update Cart items  
  
jQuery(document).on('click', '.sidesd_cross_image , .sd_mini-cart-left', function(){ 
     jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        async: false,
        cache: false,
        dataType: 'json',
        success: updateCartDesc
    });
}); 
  
 
});

/* This is for empty space*/
jQuery(document).ready(function(){
 
jQuery('.rte p').each(function() {
 var jQuerythis = jQuery(this);
 if(jQuerythis.html().replace(/\s|&nbsp;/g, '').length == 0)
     jQuerythis.remove(); });
  
  jQuery("body").on("change","textarea#notetext",function(ev){
    jQuery.ajax({
                           type: 'POST',
                          url: '/cart/update.js',
                          data: 'note=' + jQuery.trim(jQuery(this).val()),
                          dataType: 'json',
                          success:function(data){
                               console.log(data,"data");
                          }
                      
                });
  });

});

jQuery(document).ready(function() {
   $('.Size .swatch-element').each(function(){
      if($(this).hasClass( "availprod" )){
        console.log('asdasdasd');
          $(this).find('input').click();
          return false;
      }  
});
//  jQuery('.ssw-product-reviews-badge .ssw-review-count').each(function(){
//     console.log(jQuery(this).text().trim());
// if(jQuery(this).text().trim() == '(0)'){
//     jQuery(this).parent().parent().hide();
    
// }
// });
   var timeout,
       longtouch;
/*  jQuery(document).on("touchstart",".b_checkout , .sd_viewcart , .slideminicart-related a , .cartproname a", function(e) {
 //  jQuery(this).bind('touchstart', function() {
      timeout = setTimeout(function() {
          longtouch = true;
      }, 100);
   }),
     jQuery(document).on("touchend",".b_checkout , .sd_viewcart , .slideminicart-related a , .cartproname a", function(e) {
  // bind('touchend', function() {
       if (longtouch) {
        
       }
     else{
       var el = jQuery(this);
    var link = el.attr("href");
    window.location = link;
     }
       longtouch = false;
       clearTimeout(timeout);
   }); */

  
  var timeoutt,
       longtoucht;
 /* jQuery(document).on("touchstart",".sd_right .sd_continue_shopping_mobile", function(e) {
 //  jQuery(this).bind('touchstart', function() {
   
      timeoutt = setTimeout(function() {
          longtoucht = true;
      }, 200);
   }),
     jQuery(document).on("touchend",".sd_right .sd_continue_shopping_mobile", function(e) {
  // bind('touchend', function() {
       if (longtoucht) {
         
       }
     else{
       jQuery(".sd_fixminicart").removeClass("sd_fixactive"), jQuery(".sd_fixminicart").css("visibility", "visible"), jQuery(".sd_mini-cart").fadeOut("slow"), jQuery(".sd_mini-cart-items").css("right", "-100%"), jQuery("body,html").css("overflow", "auto"), jQuery("body").css({
            "overflow-x": "hidden"
        }), jQuery(window).width() < 767 && jQuery("body").css({
            position: "relative"
        });
     }
       longtoucht = false;
       clearTimeout(timeoutt);
   });
  */
  

});
